export default __webpack_public_path__ + "static/media/hht1_ep07_timeline_q05_b.ea83b3b9.png";